/* eslint-disable */
import store from '@/store/index'
import Vue from 'vue'

import MainService from './MainService'

class Calendar {
  parentLocation:any = {}

  constructor () {
    this.parentLocation = store.state.parentLocation
  }

  saveWidgetAnalitycsEvent ({ action, detail, historyInteractionType, functionalityData = null }:any) {
    Vue.prototype.$ocularAnalitycs.widgetAnalitycsEvent({
      action,
      detail,
      actionType: 'STAH',
      functionality: 4,
      functionalityData,
      historyInteractionType
    })
  }

  pushEvent (schedule:any) {
    for (let index = 0; index < schedule.availableDates.length; index++) {
      const date = schedule.availableDates[index]
      const event:Object = {
        name: 'Video atención',
        start: date,
        color: 'primary',
        timed: false,
        category: 'Video atención'
      }
      store.state.calendar.events.list.push(event)
    }

    if (schedule.availableDates.length) {
      this.saveWidgetAnalitycsEvent({
        action: 'Si hay días disponibles en el calendario',
        detail: `La búsqueda se realizó en el mes ${schedule.month} del año ${schedule.year}`,
        historyInteractionType: 'OSGOOD',
        functionalityData: {
          month: schedule.month,
          year: schedule.year,
          dates: schedule.availableDates
        }
      })
    }
  }

  getAvailableDatesSuccessHandler (response:any) {
    if (response.statusCode === 0 && response.group.schedule.availableDates) {
      this.pushEvent(response.group.schedule)
    }
    store.state.calendar.events.loading = false

    if (response.statusCode === 0 && response.group.schedule.availableDates && !response.group.schedule.availableDates.length) {
      this.saveWidgetAnalitycsEvent({
        action: 'No hay días disponibles en el calendario',
        detail: `La búsqueda se realizó en el mes ${response.group.schedule.month} del año ${response.group.schedule.year}`,
        historyInteractionType: 'OSSBAD',
        functionalityData: {
          month: response.group.schedule.month,
          year: response.group.schedule.year,
          dates: []
        }
      })
    }
  }

  getAvailableDatesErrorHandler (error:any) {
    store.state.calendar.events.loading = false
  }

  async initGetAvailableDates (params:any) {
		const hostname = !this.parentLocation.hostname.indexOf('www')
			? this.parentLocation.hostname.substring(4)
			: this.parentLocation.hostname

		const data = {
      route: 'ocular/widget/calendar/available-dates',
      params
    }

    data.params.hostname = hostname

    if (this.parentLocation.organizationCode) {
      data.params.organizationCode = this.parentLocation.organizationCode
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data
        this.getAvailableDatesSuccessHandler(res)
      })
      .catch((error) => {
        this.getAvailableDatesErrorHandler(error)
      })
  }

  getAvailableDates (params:any) {
    const storage:any = store.state.storage
    const data = {
      route: 'ocular/widget/calendar/available-dates',
      method: 'GET',
      params,
      successHandler: 'calendar.getAvailableDatesSuccessHandler',
      errorHandler: 'calendar.getAvailableDatesErrorHandler'
    }

    if (storage.form.code) {
      data.params.guestExternalId = storage.form.code
    }

    if (this.parentLocation.organizationCode) {
      data.params.organizationCode = this.parentLocation.organizationCode
    }

    try {
      let currentLocation = `${this.parentLocation.origin}${this.parentLocation.pathname}`
      currentLocation = Vue.prototype.$widget.endsWith(currentLocation, '/') ? currentLocation : `${currentLocation}/`
      data.params.url = currentLocation
    } catch (error) {
      console.log('getWidget ERROR', error)
    }

    const unSafe = store.state.unSafeDomains.find((unSafeDomain) => this.parentLocation.hostname.includes(unSafeDomain))

    if (unSafe) {
      this.initGetAvailableDates(params)
      return false
    }

    window.parent.postMessage(`mainService.apiRequest(${JSON.stringify(data)})`, '*')
  }

  // ----------------------------------------- //

  getAvailableHoursSuccessHandler (response:any) {
    if (response.statusCode === 0) {
      store.state.calendar.availableHours.list = response.group.schedule.availableHours
      store.state.calendar.availableHours.group = {
        id: response.group.id,
        name: response.group.name
      }
      store.state.calendar.availableHours.date = response.group.schedule.date
    }
    store.state.calendar.availableHours.loading = false

    if (response.statusCode === 0 && !response.group.schedule.availableHours.length) {
      this.saveWidgetAnalitycsEvent({
        action: `No hay horas disponibles para la fecha seleccionada`,
        detail: `Fecha seleccionada: ${response.group.schedule.date}`,
        historyInteractionType: 'OSSBAD',
        functionalityData: {
          date: response.group.schedule.date,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          hours: []
        }
      })
    } else if (response.statusCode === 0 && response.group.schedule.availableHours.length) {
      let hours = []
      for (let index = 0; index < response.group.schedule.availableHours.length; index++) {
        const element = response.group.schedule.availableHours[index];  
        hours.push(element.hour)
      }
      this.saveWidgetAnalitycsEvent({
        action: `Si hay horas disponibles para la fecha seleccionada`,
        detail: `Fecha seleccionada: ${response.group.schedule.date}`,
        historyInteractionType: 'OSGOOD',
        functionalityData: {
          date: response.group.schedule.date,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          hours
        }
      })
    }
  }

  getAvailableHoursErrorHandler (error:any) {
    store.state.calendar.availableHours.loading = false
  }

  async initGetAvailableHours (params:any) {
    const hostname = !this.parentLocation.hostname.indexOf('www')
			? this.parentLocation.hostname.substring(4)
			: this.parentLocation.hostname

		const data = {
      route: 'ocular/widget/calendar/available-hours',
      params
    }

    data.params.hostname = hostname

    if (this.parentLocation.organizationCode) {
      data.params.organizationCode = this.parentLocation.organizationCode
    }

    return MainService.get(data)
      .then((response) => {
        const res = response.data
        this.getAvailableHoursSuccessHandler(res)
      })
      .catch((error) => {
        this.getAvailableHoursErrorHandler(error)
      })
  }

  getAvailableHours (params:any) {
    const storage:any = store.state.storage
    const data = {
      route: 'ocular/widget/calendar/available-hours',
      method: 'GET',
      params,
      successHandler: 'calendar.getAvailableHoursSuccessHandler',
      errorHandler: 'calendar.getAvailableHoursErrorHandler'
    }

    if (storage.form.code) {
      data.params.guestExternalId = storage.form.code
    }

    if (this.parentLocation.organizationCode) {
      data.params.organizationCode = this.parentLocation.organizationCode
    }

    try {
      let currentLocation = `${this.parentLocation.origin}${this.parentLocation.pathname}`
      currentLocation = Vue.prototype.$widget.endsWith(currentLocation, '/') ? currentLocation : `${currentLocation}/`
      data.params.url = currentLocation
    } catch (error) {
      console.log('getWidget ERROR', error)
    }

    window.parent.postMessage(`mainService.apiRequest(${JSON.stringify(data)})`, '*')
  }

  // ----------------------------------------- //

  storeScheduledEventSuccessHandler (response:any) {
    store.state.calendar.scheduledEvents.response = response
    store.state.calendar.scheduledEvents.loading = false
  }

  storeScheduledEventErrorHandler (error:any) {
    store.state.calendar.scheduledEvents.error = error
    store.state.calendar.scheduledEvents.loading = false
  }

  async initStoreScheduledEvent (params:any) {
    const hostname = !this.parentLocation.hostname.indexOf('www')
			? this.parentLocation.hostname.substring(4)
			: this.parentLocation.hostname

		const data = {
      route: 'ocular/widget/calendar/scheduled-events',
      params
    }

    data.params.hostname = hostname

    if (this.parentLocation.organizationCode) {
      data.params.organizationCode = this.parentLocation.organizationCode
    }

    return MainService.post(data)
      .then((response) => {
        const res = response.data
        this.storeScheduledEventSuccessHandler(res)
      })
      .catch((error) => {
        this.storeScheduledEventErrorHandler(error)
      })
  }

  storeScheduledEvent (params:any) {
    const data = {
      route: 'ocular/widget/calendar/scheduled-events',
      method: 'POST',
      params,
      successHandler: 'calendar.storeScheduledEventSuccessHandler',
      errorHandler: 'calendar.storeScheduledEventErrorHandler'
    }

    try {
      let currentLocation = `${this.parentLocation.origin}${this.parentLocation.pathname}`
      currentLocation = Vue.prototype.$widget.endsWith(currentLocation, '/') ? currentLocation : `${currentLocation}/`
      data.params.url = currentLocation
    } catch (error) {
      console.log('getWidget ERROR', error)
    }

    data.params.channel = store.state.channel

    window.parent.postMessage(`mainService.apiRequest(${JSON.stringify(data)})`, '*')
  }
}

Vue.prototype.$calendar = new Calendar()
const calendar = <any> new Calendar()

const receiver = (event: any) => {
  const message = event.data;

  if (!message || typeof message !== 'string' || message.includes('webpack')) {
    return false;
  }

  const expression = message.split('(');
  const keyFunctionName = expression[0];
  const dataString = message.slice(`${keyFunctionName}(`.length, -1);

  const func = keyFunctionName.split('.')[1];
  const params = JSON.parse(`[${dataString}]`);

  try {
    calendar[func](...params);
  } catch (error) {
    // console.error(`Función ${keyFunctionName} no encontrada o no es una función válida.`);
  }
}

window.addEventListener('message', receiver, false);